export default "__VITE_ASSET__NwBNfslk__"